import { Text } from '@/_components';
import { RichText } from '@/_containers/inputs/rich-text';
import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';
import { noop } from '@/_shared';

import { InvoiceDetailsTabHeader } from './invoice-details-tab-header';

type InvoiceDetailsNotesTabProps = {
  invoice: InvoiceQuerySchema;
};

export function InvoiceDetailsNotesTab({ invoice }: InvoiceDetailsNotesTabProps) {
  return (
    <div className="space-y-2 px-2 py-2">
      <InvoiceDetailsTabHeader invoice={invoice} />

      <div>
        <Text className="text-c-card-muted mb-1 text-[10px] font-semibold tracking-wide uppercase">Notes</Text>
        <div className="border-c-border rounded border px-2 py-2">
          {invoice.notes ? (
            <RichText
              value={invoice.notes}
              onChange={noop}
              disabled
              inline
              className="text-c-card-foreground text-xs [&_*]:text-xs"
            />
          ) : (
            <Text className="text-c-card-muted text-xs">No notes for this invoice.</Text>
          )}
        </div>
      </div>
    </div>
  );
}
